import React, { useState, useEffect, Suspense, lazy } from 'react';
import { Box, Flex, StyledProgressiveImage } from 'src/kit';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import * as S from './styled';

const Slider = lazy(() => import('react-slick'));

import logo1 from 'images/update_landing/companies/Alexa_Capital.png';
import logo3 from 'images/update_landing/companies/Banque-Hottinguer.png';
import logo4 from 'images/update_landing/companies/Cathay-Capital.png';
import logo5 from 'images/update_landing/companies/CNP.png';
import logo6 from 'images/update_landing/companies/D_Angelin_Co.png';
import logo7 from 'images/update_landing/companies/FDC.png';
import logo8 from 'images/update_landing/companies/Greenhill.png';
import logo9 from 'images/update_landing/companies/Infravia.png';
import logo10 from 'images/update_landing/companies/Meanings.png';
import logo11 from 'images/update_landing/companies/Sagard.png';
import logo12 from 'images/update_landing/companies/Zaoui&Co.png';

const responsive = [
  {
    breakpoint: 1300,
    settings: {
      slidesToShow: 4
    }
  },
  {
    breakpoint: 1000,
    settings: {
      slidesToShow: 3
    }
  },
  {
    breakpoint: 800,
    settings: {
      slidesToShow: 2
    }
  }
];

const Image = props => (
  <StyledProgressiveImage
    mx="auto"
    backgroundSize="contain"
    backgroundRepeat="no-repeat"
    backgroundPosition="center"
    {...props}
  />
);

const SliderInner = () => {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  if (!isClient) {
    return null;
  }

  return (
    <S.SliderWrapper>
      <Slider
        responsive={responsive}
        mobileFirst
        infinite
        autoplay
        autoplaySpeed={0}
        speed={3000}
        slidesToScroll={1}
        slidesToShow={5}
        arrows={false}
      >
        <Image src={logo1} alt="company icon" height={80} />
        <Image src={logo3} alt="company icon" height={50} />
        <Image src={logo4} alt="company icon" height={80} />
        <Image src={logo5} alt="company icon" height={60} />
        <Image src={logo6} alt="company icon" height={130} />
        <Image src={logo7} alt="company icon" height={50} />
        <Image src={logo8} alt="company icon" height={80} />
        <Image src={logo9} alt="company icon" height={80} />
        <Image src={logo10} alt="company icon" height={50} />
        <Image src={logo11} alt="company icon" height={80} />
        <Image src={logo12} alt="company icon" height={35} />
      </Slider>
    </S.SliderWrapper>
  );
};

const CompaniesSlider = ({ bg = '#F4F6F9', ...props }: { bg?: string; [key: string]: any }) => (
  <Box as="section" py={5} {...props} bg={bg}>
    <Flex width={1} flexDirection="column" justifyContent="center">
      <Suspense fallback={null}>
        <SliderInner />
      </Suspense>
    </Flex>
  </Box>
);

export default CompaniesSlider;
